import * as React from 'react'
import { DeliveryIssueTypes } from '../../../../models/types'
import NeverDelivered from './never-delivered'
import ExtremelyLate from './extremely-late'

type Takeover = {
    type?: DeliveryIssueTypes
}

// Need some marker here to know that the delivery issue is
// Late or Never Delivered
const Takeover: React.FunctionComponent<Takeover> = props => {

  if(props.type === DeliveryIssueTypes.ExtremelyLate) {
    return <ExtremelyLate />
  }

  return <NeverDelivered />
}

export const DisconnectedTakeover = Takeover
export default Takeover